const { default: styled } = require("styled-components");

export const ModalCopyPixKeyContainer = styled.div`
  height: 100%;
.modal-window2 {
    position: fixed;
    background-color: rgb(0 0 0 / 15%);
    backdrop-filter: blur(1.2px);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999999;
    opacity: 0;
    transition: all 0.3s;
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    
    & > div {
      width: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      color:#000;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, -50%);
      padding: 1em;
      background: #33bcad;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  
  .modal-close {
    color: #aaa;
    line-height: 50px;
    font-size: 80%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 0;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  
  /* Demo Styles */
  

  
  a {
    color: inherit;
  }
  
  .container {
    /* display: grid;
    justify-content: center;
    align-items: center; */
    /* height: 100vh; */
  }
  
  .modal-window2 {
    & > div {
      border-radius: 0.3rem;
    }
  }
  
  .modal-window2 div:not(:last-of-type) {
    margin-bottom: 15px;
  }
  
  small {
    color: lightgray;
  }
  
  .btn {
    i {
      padding-right: 0.3em;
    }
  }

  /* List */
    ul {
      counter-reset: index;  
      padding: 0;
      max-width: 300px;
    }

    /* List element */
    li {
      counter-increment: index; 
      display: flex;
      align-items: center;
      padding: 12px 0;
      box-sizing: border-box;
    }


    /* Element counter */
    li::before {
      content: counters(index, ".", decimal-leading-zero);
      font-size: 1.5rem;
      text-align: right;
      font-weight: bold;
      min-width: 50px;
      padding-right: 12px;
      font-variant-numeric: tabular-nums;
      align-self: flex-start;
      background-image: linear-gradient(to bottom, aquamarine, orangered);
      background-attachment: fixed;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }


    /* Element separation */
    li + li {
      border-top: 1px solid rgba(255,255,255,0.2);
    }


    div.list {
    counter-reset: list-number;
    }
    
    div.list div:before {
    counter-increment: list-number;
    content: counter(list-number);
    
    margin-right: 10px;
    margin-bottom:10px;
    width:35px;
    height:35px;
    display:inline-flex;
    align-items:center;
    justify-content: center;
    font-size:16px;
    background-color:palegreen;
    border-radius:50%;
    color:#fff;
    }

    .footer-modal{
        display:flex;
        justify-content:center;
        align-items:center;
    }
  
`